import { useParams } from "./useParams"

export function useTableParams(): [
  Record<string, string | string[] | undefined>,
  (params: Record<string, string>) => void,
] {
  const [params, setParams] = useParams()

  const updateParams = (newParams: Record<string, any>) => {
    setParams({ page: undefined, ...newParams })
  }
  return [params, updateParams]
}
